import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logDataToConsole, logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

interface ProcessCsvPayload {
  gs_path: string;
  org_id: string;
}

export const processCsvForPharmacyPa = async (payload: ProcessCsvPayload) => {
  try {
    const token = await getBearerToken();

    if (!token) {
      throw new Error("Bearer token not available");
    }

    logDataToConsole("Processing CSV payload", payload);

    const response = await fetch(API_ENDPOINTS.PROCESS_CSV_PHARMACY_PA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `CSV processing failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }

    const result = await response.json();
    logDataToConsole("CSV processing successful", result);
    return result;
  } catch (error) {
    logError(error as Error, "Error in processCsvForPharmacyPa");
    throw error;
  }
};
